export default __webpack_public_path__ + "static/media/image00029.41e71be7.jpeg";